/* eslint-disable react-hooks/exhaustive-deps */
import get from 'lodash/get'
import { useEffect } from 'react'
import { version, name } from 'package.json'
import { sendEvent } from '@blocket/tracking'
import { useSelector, shallowEqual } from 'react-redux'
import featuresPlugin from '@blazar-plugins/features'
import devicePlugin from '@blazar-plugins/device'

const GlobalData = () => {
  const loginStatus = useSelector((state) => (get(state, 'account.user.loggedIn') ? 1 : 0))
  const actorId = useSelector((state) => get(state, 'account.user.id'))
  const environment = useSelector((state) => state.config.tealium.environment)
  const adblockDetected = useSelector((state) => (state.adBlocker.isActive ? 1 : 0))
  const enabledFeatures = useSelector(
    (state) => featuresPlugin.selectors.allEnabledFeatureNames(state),
    shallowEqual,
  )
  const screenType = useSelector((state) => devicePlugin.selectors.screenType(state))

  useEffect(() => {
    sendEvent({
      appName: name,
      appVersion: version,
      environment,
      loginStatus,
      actorId,
      adblockDetected,
      enabledFeatures,
      screenType,
    })
  }, [
    loginStatus,
    actorId,
    environment,
    adblockDetected,
    JSON.stringify(enabledFeatures),
    screenType,
  ])

  return null
}

export default GlobalData
